import React__default, { useState, useEffect } from 'react';
import { Button } from './Button.js';

const ToggleButton = (props) => {
    const [selected, setSelected] = useState(props.isSelected ?? props.defaultSelected ?? false);
    // Sync internal state if isSelected prop changes
    useEffect(() => {
        if (props.isSelected !== undefined) {
            setSelected(props.isSelected);
        }
    }, [props.isSelected]);
    const handleChange = (newSelected) => {
        if (props.isDisabled) {
            return;
        }
        setSelected(newSelected);
        props.onChange?.(newSelected);
    };
    return (React__default.createElement(Button, { ...props, className: props.className, "aria-pressed": selected, variant: selected ? (props.selectedVariant ?? 'filled') : (props.variant ?? 'outline'), onPress: () => handleChange(!selected) }));
};
ToggleButton.displayName = 'ToggleButton';

export { ToggleButton };
//# sourceMappingURL=ToggleButton.js.map
